import axios from 'axios'

// Create an Axios instance
const apiAddress = axios.create({
  baseURL: "https://pcls1.craftyclicks.co.uk/json/",
  // Add any additional configuration as needed
})

export default apiAddress
